import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ds';
import { usePWAInstallPrompt } from '@/hooks/usePWAInstallPrompt';

export function AppInstallPrompt() {
  const { t } = useTranslation();
  const { canInstall, promptInstall, dismissPrompt } = usePWAInstallPrompt();

  if (!canInstall) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl border border-neutral-100">
        <div className="flex items-center gap-4 mb-4">
          <div className="w-14 h-14 rounded-xl bg-primary-50 flex items-center justify-center">
            <img
              src="/logo.svg"
              alt={t('screens.appInstallPrompt.dentacaresLogo')}
              className="h-10 w-auto"
            />
          </div>
          <div>
            <p className="text-sm font-semibold text-primary-600 uppercase tracking-wide">
              {t('screens.appInstallPrompt.installApp')}
            </p>
            <h2 className="text-2xl font-bold text-neutral-900">
              {t('screens.appInstallPrompt.dentacaresPWA')}
            </h2>
          </div>
        </div>

        <p className="text-neutral-600 text-sm mb-6">
          {t('screens.appInstallPrompt.addDentacaresToYourHome')}
        </p>

        <div className="flex flex-col sm:flex-row gap-3">
          <Button className="flex-1" onPress={promptInstall}>
            {t('screens.appInstallPrompt.installNow')}
          </Button>
          <Button
            type="button"
            variant="secondary"
            className="flex-1"
            onPress={dismissPrompt}
          >
            {t('screens.appInstallPrompt.maybeLater')}
          </Button>
        </div>
      </div>
    </div>
  );
}
